<div class="content">
    <mat-slide-toggle
  
    class="setting"
    color="primary"
    [checked]="useRandomServiceLevelAssignment"
    (toggleChange)="toggleRandomAssignment()"
  >
  Use random assignment to families
  </mat-slide-toggle>
  <!-- [(ngModel)]="useRandomServiceLevelAssignment" -->
  <div class="subheader-text">
    <span class="subheader">Service Levels</span>
  </div>
  <div class="group" *ngFor="let serviceLevel of serviceLevels">
    <div class="group-content">
      <div class="group-avatar"[style.background-color]="getColorFromName(serviceLevel.name)">{{serviceLevel.name.substring(0,1)}}</div>
      <div class="group-text">
        <div class="group-name">{{serviceLevel.name}}</div>
        <div class="group-desc">{{getServicesAsString(serviceLevel)}} 
          <span *ngIf="!serviceLevel.familyCount || serviceLevel.familyCount === null">(0</span>
          <span *ngIf="serviceLevel.familyCount && serviceLevel.familyCount != null">({{serviceLevel.familyCount}}</span> families)
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="editServiceLevel(serviceLevel)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button *ngIf="!serviceLevel.familyCount || serviceLevel.familyCount === null || serviceLevel.familyCount === 0" (click)="deleteServiceLevel(serviceLevel)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="editServiceLevel(undefined)">
  + Add new
    </button>
  </div>

</div>
